import { QueryClient } from '@tanstack/react-query';

/**
 * Stale time defaults per domain (milliseconds)
 * Aligned with cache.config.ts SERVICE_CACHE_DURATIONS
 */
export const staleTimes = {
  /** Collector stats: 30 seconds (changes on sync) */
  collectorStats: 30 * 1000,
  /** Collector data: 2 minutes (settings, addresses, artworks) */
  collectorData: 2 * 60 * 1000,
  /** Collector events/bids: 2 minutes */
  collectorEvents: 2 * 60 * 1000,
  /** Catalog data: 5 minutes (semi-static) */
  catalog: 5 * 60 * 1000,
  /** Insights/leaderboard: 1 minute */
  insights: 60 * 1000,
} as const;

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: staleTimes.catalog,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
}
